import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import PincodeDetail from './components/PincodeDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageTax',
  components: {
    PincodeDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;